import React, { FC } from 'react';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { ProductiveHeading05 } from 'ozone/atoms';
import { OzoneDrawerProps } from './ozone-drawer';

const Container = styled.div`
  background-color: var(--coolest-gray-10);
  padding: 16px 24px;
  border-bottom: none;
  position: sticky;
  top: 0;
  z-index: 1;
`;

const Title = styled.h5`
  ${ProductiveHeading05};
`;

const SubTitle = styled.p`
  ${BodyShort01};
`;

export const Header: FC<Pick<OzoneDrawerProps, 'title' | 'subTitle'>> = ({
  title,
  subTitle,
}) => (
  <Container>
    {title ? <Title>{title}</Title> : null}
    {subTitle ? <SubTitle>{subTitle}</SubTitle> : null}
  </Container>
);
